import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export interface MontyActionView {
	type: 'CONFIRM_ON_FLIGHT' | 'MOVE_TO_FLIGHT' | 'REMOVE_FROM_FLIGHT';
	flightId: string;
	label: string;
	alternatives?: Array<{ flightId: string; label: string }>;
}

/**
 * Monty action card (088): shows the proposed booking action above the
 * composer. Accept requires the explicit button; the flight can be re-picked
 * from the pre-validated alternatives before accepting. Pure presentational —
 * the parent executes the mutation and owns the state.
 */
@Component({
	selector: 'app-monty-action-card',
	templateUrl: './monty-action-card.component.html',
	styleUrls: ['./monty-action-card.component.scss'],
})
export class MontyActionCardComponent implements OnChanges {
	@Input() action: MontyActionView;
	@Input() busy = false;
	@Input() failureReason: string | null = null;
	@Output() accept = new EventEmitter<string>(); // emits the (possibly re-picked) flightId
	@Output() dismiss = new EventEmitter<void>();

	pickedFlightId: string | null = null;
	pickedLabel: string | null = null;
	hideFailure = false;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.action) {
			// Angular reuses this instance when a newer proposal supersedes the
			// old one — a re-picked flight must never carry over to a new action.
			this.pickedFlightId = null;
			this.pickedLabel = null;
			this.hideFailure = false;
		}
		if (changes.failureReason) {
			this.hideFailure = false;
		}
	}

	get flightLabel(): string {
		return this.pickedLabel || this.action?.label || '';
	}

	pick(option: { flightId: string; label: string }): void {
		this.pickedFlightId = option.flightId;
		this.pickedLabel = option.label;
		this.hideFailure = true; // never mutate the @Input itself
	}

	onAccept(): void {
		this.accept.emit(this.pickedFlightId || this.action.flightId);
	}
}
